<!--
 * @Description: 
 * @Author: xz
 * @Date: 2023-11-14 14:32:24
 * @LastEditTime: 2023-11-22 08:51:05
 * @LastEditors: xz
-->
<template>
  <div id="container" v-loading="loading">
    <multiChart :chartdata="chartData" height="100%" width="100%" />
  </div>
</template>

<script>
import multiChart from "@/components/charts/echatline";
import userApi from "@/api/user";

export default {
  components: {
    multiChart,
  },
  data() {
    return {
      chartData: [],
      loading:false
    };
  },
  watch: {},
  methods: {
    init() {
        this.loading=true
      userApi.getFloatData().then((res) => {
        if (res.data.data) {
          res.data.data.forEach((item) => {
            //console.log(2222)
            for (let i in item) {
              //console.log(1111,item[i],i)
              this.chartData.push({
                name: i,
                smooth: true,
                showSymbol: false,
                type: "line",
                data: item[i],
                sampling: "lttb",
              });
            }
          });
          this.loading=false
          //console.log(" this.chartData", this.chartData)
        }
      });
    },
  },
  created() {
    this.init();
  },
  destroyed() {},
  mounted() {},
};
</script>
<style scoped  >
#container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Float.vue